import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MediaMediasBridge } from './bridges/media_medias.bridge';
import { MEDIAS_FEATURE_KEY } from './keys';
import { mediasReducer } from './reducers/medias.reducer';
import { MediasEffects } from './effects/medias.effects';

export function provideMediasStore(): EnvironmentProviders[] {
    return [provideState(MEDIAS_FEATURE_KEY, mediasReducer), provideEffects(MediasEffects, MediaMediasBridge)];
}
